import { siteRoutes } from "@/routes/siteRoutesList";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { MixIcon } from "@radix-ui/react-icons";

// Route Props
interface RouteProps {
  title: string;
  link: string;
  logo: any;
}

export const LEGO_siteRoutes = ({ authRole }: { authRole: boolean }) => {
  const routes: { [key: string]: RouteProps[] } = {
    "routes.headlines.engagement": [
      brand.hasFeature.challenges && {
        title: "routes.route.overview",
        link: siteRoutes["challenges"],
        logo: MixIcon,
      },
      brand.hasFeature.challenges && {
        title: "LEGO F1 Challenge",
        link: siteRoutes["f1"],
        logo: MixIcon,
      },
    ].filter(Boolean) as RouteProps[],
    "routes.headlines.admin": [
      authRole && {
        title: "routes.route.submissions",
        link: siteRoutes["submissions"],
        logo: MixIcon,
      },
    ].filter(Boolean) as RouteProps[],
  };

  return routes;
};
